import styles from './SideBarStyles.module.scss'

function SideBar({buttonsInfo}) {
    return (<div className={styles.buttonsContainer}>
        {buttonsInfo.map((item, i) => (
            <div className={styles.button} key={i} onClick={item.onClick}>
                {item.icon}
            </div>
        ))}
    </div>)
}

export default SideBar;